import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F1EDE4] text-[#6B5D57]">
        <div className="flex items-center gap-3">
          <div className="h-2 w-2 rounded-full bg-[#7A1E2E] animate-pulse" />
          <span className="text-sm">Cargando sesión...</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
